<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isVisible"
  (nzVisibleChange)="onIsVisibleChange($event)"
  [nzTitle]="'Invite People to Workspace'"
  (nzOnCancel)="onCancelClick()"
>
  <ng-container *nzModalContent>
    <div [@stepTransition]="currentStepIndex()" class="modal-content">
      @switch (currentStepIndex()) {
        @case (0) {
          <div class="step-content vertical">
            <div class="vertical">
              <h3>Please enter member emails. (Up to {{ availableMemberCount - userList().length }} emails)</h3>
              @for (email of emailList(); track i; let i = $index) {
                <div class="horizontal">
                  <input nz-input nzSize="large" placeholder="Email" [(ngModel)]="emailList()[i]" />
                  <button nz-button nzType="default" nzSize="large" (click)="onDeleteEmailClick(i)">
                    <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
                  </button>
                </div>
              }
              <button class="fit-content" nz-button nzType="default" nzSize="large" (click)="onAddEmailClick()">
                <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
                Add Email
              </button>
            </div>
          </div>
        }
        @default {
          <div class="step-content vertical">
            <div class="vertical">
              <h3>Added Members</h3>
              @for (boardBackend of addUserListResponse()?.addedBoardList; track $index) {
                @if (boardBackend.userBoardConfig) {
                  <app-board-icon-title [board]="boardBackend"></app-board-icon-title>
                }
              }
            </div>

            <div class="vertical">
              <h3>Pending Member Invites</h3>
              @for (item of pendingEmailList(); track $index) {
                <div>{{ item.email }}</div>
              }
            </div>
          </div>
        }
      }
    </div>
  </ng-container>

  <div *nzModalFooter class="horizontal seperate full-width">
    <button nz-button nzType="default" [nzLoading]="isLoading()" (click)="onCancelClick()">Cancel</button>

    <div class="horizontal">
      @if (currentStepIndex() < totalSteps) {
        <button nz-button nzType="primary" [nzLoading]="isLoading()" (click)="onInviteClick()">Invite</button>
      } @else if (currentStepIndex() === totalSteps) {
        <button nz-button nzType="default" [nzLoading]="isLoading()" (click)="onCancelClick()">Close</button>
      }
    </div>
  </div>
</nz-modal>
